import React from 'react';
import { SimpleTableCustomCellProps } from '../simple-table-row/simple-table-row.props';
import { Flex } from 'common/common-components.styled';

const CustomCell = <TRow,>({ column, row }: SimpleTableCustomCellProps<TRow>) => {
  return (
    <Flex width={column.width || '100%'} align='center' justify='center'>
      {column.rowComponent(row)}
    </Flex>
  );
};

export default CustomCell;
